<template>
	<div ref="EmergencyAlarm" class="dialog-container">
		<div class="dialog alarm" style="transform: translate(0, -280px); max-width: 90%;">
			<img style="width: 68px; height: 95px;" src="@/assets/images/home/alarm_icon.png" />
			<span style="margin-top: 22px;">응급 환자가 발생했습니다.</span>
			<div class="alarm-user">
				<template
					v-for="(user, index) in topEmergencyList"
				>
					<span
						:key="index"
					>
						{{ '('+user.name+' '+user.id+')' }}
					</span>
				</template>
			</div>
			<button type="button" class="btn-cancel" style="margin: 0;" title="확인" @click="doCancel()">
				확인
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "EmergencyAlarm",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
	},
	data() {
		return {
			item: {},
			isTab: 1,
		};
	},
	components:{
	},
	props: {
		topEmergencyList: {
			type: Object,
			required: true
		}
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.doClose();
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.EmergencyAlarm.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.EmergencyAlarm.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
.alarm{
	height: 420px;
	background-color: rgb(0, 0, 0, 0.7);
	border: none;
	color: #fff;
	display: flex;
    flex-direction: column;
    align-items: center;
	justify-content: center;
	font-size: 48px;
	font-weight: bold;
}
.alarm-user{
	background-color: #707070;
	font-size: 26px;
	min-width: 500px;
	height: 55px;
	display: flex;
    justify-content: center;
    align-items: center;
	margin: 15px 0 35px 0;
	padding: 0 20px;
	column-gap: 10px;
}
</style>